import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent as _logEvent, isSupported } from 'firebase/analytics';
import { firebaseConfig } from './config';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);

// Analytics — initialise only in environments that support it (blocks SSR / Node)
let analyticsInstance = null;
isSupported().then(yes => {
  if (yes) analyticsInstance = getAnalytics(app);
});

// Safe wrapper — drops silently if analytics isn't available yet
export const logEvent = (eventName, params = {}) => {
  if (analyticsInstance) _logEvent(analyticsInstance, eventName, params);
};

export default app;